module.exports.RESOURCES = [
  { key: 'food', char: '\ue904' },
  { key: 'fuel', char: '\ue905' },
  { key: 'water', char: '\ue90a' }
];

module.exports.UNREST = [
  { key: 'conflict', char: '\ue902' },
  { key: 'demo', char: '\ue903', label: 'Demonstrations', labelShort: 'Demos' },
  { key: 'looting', char: '\ue906' },
  { key: 'protest', char: '\ue907' },
  { key: 'riot', char: '\ue908' },
  { key: 'suicide', char: '\ue909' }
];



// WEBPACK FOOTER //
// ./lib/options-config.js